import Trainers from "../components/Trainers";

export default function TrainersPage() {
  return (
    <div data-testid="trainers-page" className="pt-20">
      <Trainers />
    </div>
  );
}
